import './styles.scss'

import { ChangeEvent, FormEvent, ReactNode, useEffect, useState } from 'react'

import {
  ApproveInGroup,
  CheckmarkIcon,
  PencilIcon
} from '../../../assets/icons'
import * as Styled from '../styled'
import i18n from 'i18n'
import { Box, Grid, Typography } from '@mui/material'
export interface InputWithActionProps {
  disabled?: boolean
  initialText: string
  editState: boolean
  setLoading: (b: boolean) => void
  setEditState: (b: boolean) => void
  onSubmit: (s: string) => Promise<boolean>
  nonActiveChild?: ReactNode
}

export default function InputWithAction(props: InputWithActionProps) {
  //we have 2 states of input field(edit/showing), so we keep title in the usestate
  const [title, setTitle] = useState(props.initialText)
  useEffect(() => {
    setTitle(props.initialText)
  }, [props.initialText])

  const [showCheckmark, setShowCheckmark] = useState(false)

  const onTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length > 25) return
    setTitle(event.target.value)

    if (event.target.value !== props.initialText) {
      setShowCheckmark(true)
    } else {
      setShowCheckmark(false)
    }
  }

  const toggleEditName = () => {
    props.setEditState(true)
  }

  return (
    <Styled.GroupPopupInput
      value={title}
      shouldNotFocus
      id="group-name-input"
      onChange={onTitleChange}
      sx={{
        pointerEvents: props.disabled ? 'none !important' : 'all',
        paddingTop: '4px',
        paddingBottom: '4px'
      }}
      component={
        !props.disabled &&
        showCheckmark && (
          <Box
            display={'flex'}
            flexDirection={'row'}
            alignItems={'flex-end'}
            gap={0.5}
          >
            <Typography fontSize={12}>{25 - title.length}</Typography>
            <Styled.GroupPopupInputButton
              id="save-group-name-button"
              onClick={() => {
                props.onSubmit(title)
                setShowCheckmark(false)
              }}
            >
              <ApproveInGroup />
            </Styled.GroupPopupInputButton>
          </Box>
        )
      }
    />
  )
}
